import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    accountOpening: {
      subtitle: 'The company already has its SIRET number.',
      title: 'Open a Shine account',
    },
    accountOpeningSectionHeader: 'Ouverture de compte',
    capitalDeposit: {
      subtitle: 'The company’s draft statutes have already been written.',
      title: 'Make a capital deposit',
    },
    companyCreation: {
      subtitle: 'Create your SASU, EURL, SARL, SAS, auto-entreprise...',
      title: 'Create a company',
    },
    companyCreationSectionHeader: 'Company creation',
    soon: 'Coming soon',
    title: 'What would your like to do for your client?',
  },
  fr: {
    accountOpening: {
      subtitle: 'La société a déjà son numéro SIRET.',
      title: 'Ouvrir un compte Shine',
    },
    accountOpeningSectionHeader: 'Ouverture de compte',
    capitalDeposit: {
      subtitle: 'Les statuts de l’entreprise sont déjà rédigés.',
      title: 'Effectuer un dépôt de capital',
    },
    companyCreation: {
      subtitle: 'Créer votre SASU, EURL, SARL, SAS, auto-entreprise...',
      title: 'Créer une entreprise',
    },
    companyCreationSectionHeader: 'Création d’entreprise',
    soon: 'Bientôt disponible',
    title: 'Que souhaitez vous faire pour votre client•e\u00A0?',
  },
} as const);

export default locales;
